import { Ajax } from 'utils/ajax';

'use strict';

/* global $ */

class Embroidery {
  constructor() {
      this.init();
  }
  init() {
      console.log('[ Embroidery ] init');

      this.jsAddFile();
      this.jsRemoveFile();
      this.jsChangeFigures();
  }
  jsAddFile() {
    $('.js-addfile').on('change',function(){
      $('.js-delfile').css('display','inline-block');
    })
  }
  jsRemoveFile() {
    $('.js-delfile').on('click',function(){
      $('.js-addfile').val('');
      $('.js-embroidery__name').text(' ');
      $(this).css('display','none');
    });
  }
  jsChangeFigures() {
    function jsUpdatePrice() {
      var count = $('.js-embroidery .js-number-box').val();
	    var design = $('.js-embroidery').data('design') * 1;
	    var item_price = $('.js-embroidery').data('item_price') * 1;
      console.warn(count);
      var width = $('.js-embroidery .js-width').val();
      var height = $('.js-embroidery .js-height').val();
      if (count > 0) {
        var price = item_price*width*height + design;
        if (count > 1) price += .5*price*(count - 1);
        price = Math.round(price/50)*50;
      } else {
        price = 0;
      }
      $('.js-embroidery__sum b').text(price);
  		if (price) {
  			$('.js-embroidery__sum').parent().removeClass('m--hidden');
  			$('.js-embroidery__none').hide();
  		} else {
  			$('.js-embroidery__sum').parent().addClass('m--hidden');
  			$('.js-embroidery__none').show();
  		}
      if (count > 0) {
        $('.js-embroidery').removeClass('m--disabled');
      } else {
        $('.js-embroidery').addClass('m--disabled');
      }
    }
    function newfunk() {
      if ($('.js-cart-add').data('num_id')) {
        $('.js-cart-add').css('display','block');
      }
    }
      $('.js-embroidery .js-number-box').on('keyup',function(){
        if ($(this).val() < 0) $(this).val = 0;
        jsUpdatePrice();
      })
      $('.js-embroidery .js-aks-min').on('click',function(){
        if ($(this).siblings('input').val() * 1 > $(this).siblings('input').attr('min') * 1) {$(this).siblings('input').val(Number($(this).siblings('input').val()) - 1);}
        jsUpdatePrice();
        var input = new FormData(document.getElementById('embroidery_form'));
        $.ajax({method: 'POST', url:'/constructor/Update_Fancywork/', data:input, processData: false, contentType: false, dataType:'json'}).then((data) => {
          if (data.ok) {
              console.log(data);
              newfunk();
          }
        })
      })
      $('.js-embroidery .js-aks-plus').on('click',function(){
        if ($(this).val() < 0) $(this).val = 0;
        //$(this).siblings('input').val(Number($(this).siblings('input').val()) + 1);
        if ($(this).siblings('input').val() * 1 < $(this).siblings('input').attr('max') * 1) {$(this).siblings('input').val(Number($(this).siblings('input').val()) + 1);}
        jsUpdatePrice();
        var input = new FormData(document.getElementById('embroidery_form'));
        $.ajax({method: 'POST', url:'/constructor/Update_Fancywork/', data:input, processData: false, contentType: false, dataType:'json'}).then((data) => {
          if (data.ok) {
              console.log(data);
              newfunk();
          }
        })
      })
      $('.js-embroidery .js-width').on('input',function(e){
		e.preventDefault();
		e.stopImmediatePropagation();
		var v = $(this).val();
		if (/\D/g.test(v)) {
			v = this.value.replace(/\D/g, '');
		}
        if (1 * v < 1 * $(this).attr('min')) {
			v = $(this).attr('min');
		}
        if (1 * $(this).val() > 1 * $(this).attr('max')) {
			v = $(this).attr('max');
		}
		$(this).val(v);
        jsUpdatePrice();
        var input = new FormData(document.getElementById('embroidery_form'));
        $.ajax({method: 'POST', url:'/constructor/Update_Fancywork/', data:input, processData: false, contentType: false, dataType:'json'}).then((data) => {
          if (data.ok) {
              console.log(data);
              newfunk();
          }
        })
      })
      $('.js-embroidery .js-height').on('input',function(e){
		e.preventDefault();
		e.stopImmediatePropagation();
		var v = $(this).val();
		if (/\D/g.test(v)) {
			v = this.value.replace(/\D/g, '');
		}
        if (1 * v < 1 * $(this).attr('min')) {
			v = $(this).attr('min');
		}
        if (1 * $(this).val() > 1 * $(this).attr('max')) {
			v = $(this).attr('max');
		}
		$(this).val(v);
        jsUpdatePrice();
        var input = new FormData(document.getElementById('embroidery_form'));
        $.ajax({method: 'POST', url:'/constructor/Update_Fancywork/', data:input, processData: false, contentType: false, dataType:'json'}).then((data) => {
          if (data.ok) {
              console.log(data);
              newfunk();
          }
        })
      })
	  jsUpdatePrice();
    }
}

export {
  Embroidery
}
